import * as React from 'react';
import classnames from 'classnames';

import CampaignTimelineOverview from './overview/CampaignTimelineOverview';

import { __t, applyTranslations } from 'utils/language';

import './campaign-timeline.scss';

applyTranslations(require('./campaign-timeline.i18n.json'));

import { CcmCampaignTimeline } from '../../../ccm/types/CcmCampaignTimeline.type';

type Props = {
  timeline: CcmCampaignTimeline | null,
  withSlimLayout?: boolean
};

const MSG_KEY = 'campaign_timeline';

const CampaignTimeline: React.FC<Props> = ({
  timeline,
  withSlimLayout
}): JSX.Element => {
  const isSlimLayout = Boolean(withSlimLayout);

  const containerClasses = classnames('campaign-timeline', {
    'campaign-timeline--with-slim-layout': isSlimLayout
  });

  const overviewClasses = classnames('campaign-timeline__overview', {
    'campaign-timeline__overview--with-slim-layout': isSlimLayout
  });

  return (
    <div className={containerClasses}>
      {
        !isSlimLayout && (
          <React.Fragment>
            <div className="campaign-timeline__heading">
              {__t(`${MSG_KEY}.heading`)}
            </div>
            <div className="campaign-timeline__subheading">
              {__t(`${MSG_KEY}.subheading`)}
            </div>
          </React.Fragment>
        )
      }
      <div className={overviewClasses}>
        <CampaignTimelineOverview
          timeline={timeline}
        />
      </div>
    </div>
  );
};

export default CampaignTimeline;
